import React from "react";
import PropTypes from "prop-types";
import { DE, ES, FR, IT, NL, BR, TR, CN, JP, Globe } from "../icons/flags";

// Do NOT define any SVG here — all flag shapes live in src/icons/flags.jsx.

// Keys are Title Case (canonical form). Lookup is case-insensitive.
// To add a new language: create a flag SVG above, then add one entry here.
export const LANGUAGE_FLAG_MAP = {
  German: { component: DE, label: "Germany" },
  Spanish: { component: ES, label: "Spain" },
  French: { component: FR, label: "France" },
  Italian: { component: IT, label: "Italy" },
  Dutch: { component: NL, label: "Netherlands" },
  "Portuguese (Brazil)": { component: BR, label: "Brazil" },
  Turkish: { component: TR, label: "Turkey" },
  "Chinese (Simplified)": { component: CN, label: "China" },
  Chinese: { component: CN, label: "China" },
  Japanese: { component: JP, label: "Japan" },
};

const findEntry = (language = "") => {
  if (LANGUAGE_FLAG_MAP[language]) return LANGUAGE_FLAG_MAP[language];
  const lower = language.toLowerCase();
  const key = Object.keys(LANGUAGE_FLAG_MAP).find((k) => k.toLowerCase() === lower);
  return key ? LANGUAGE_FLAG_MAP[key] : null;
};

FlagIcon.propTypes = {
  language: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

export function FlagIcon({ language = "", size = 20, className = "" }) {
  const entry = findEntry(language);
  const Flag = entry ? entry.component : null;

  return (
    <span
      title={language}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "stretch",
        height: `${size}px`,
        width: `${Math.round(size * 1.5)}px`,
        flexShrink: 0,
        borderRadius: 2,
        overflow: "hidden",
        lineHeight: 0,
        fontSize: 0,
      }}
    >
      {Flag ? <Flag /> : <Globe />}
    </span>
  );
}
